module.exports = __webpack_public_path__ + "media/packs/images/flags/NA-64d6f8b04d86060005b8f1c4fbb0b62c.svg";